module.exports = __webpack_public_path__ + "img/deleteBgImageWhite.b2fe1eb2.svg";